import { PRIMARY_COLOR } from "../_const/color.const";

export const loginStyles = {

    appScreen: {
        //backgroundImage: "url(" + img + ")",
        //height: '100vh'
        backgroundColor: "#004990",
        minHeight: "calc(100vh - 0.5px)"
    },
    appLogo: {
        width: "calc(100% - 150px)",
        margin: "10px auto",
        display: "block",
    },
    logoBox: {
        marginTop: "60px",
        marginBottom: "40px",
        padding: "10px 0px",
    },
    loginBox: {
    },
    mainBackground: {
        backgroundColor: PRIMARY_COLOR[0],
        paddingTop: "10px",
    },
    ieBox: {
        maxWidth: "650px",
        margin: "0px auto",
        paddingBottom: "30px"
    }
};